export default {"src":"/_next/static/media/hospital-svgrepo-com.74c604f8.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};